import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectADAndDBenefitsTugo = (state) => state.get('adAndDBenefitsTugo');

const safeToJS = (val, defaultVal) =>
  (val && typeof val.toJS === 'function' ? val.toJS() : (Array.isArray(val) ? val : defaultVal));

const makeSelectADAndDBenefitsTugo = () =>
  createSelector(selectADAndDBenefitsTugo, (adAndDState) => ({
    whatExpensesAreYouClaimingFor: mapWithDefault(
      adAndDState,
      () => safeToJS(adAndDState.getIn(['form', 'whatExpensesAreYouClaimingFor']), []),
      []
    ),
    airFlightCommonCarrierAccidentItems: mapWithDefault(
      adAndDState,
      () => safeToJS(adAndDState.getIn(['form', 'airFlightCommonCarrierAccidentItems']), []),
      []
    ),
    accident24HourItems: mapWithDefault(
      adAndDState,
      () => safeToJS(adAndDState.getIn(['form', 'accident24HourItems']), []),
      []
    ),
    accidentalDeathAndDismembermentParentSelected: mapWithDefault(
      adAndDState,
      () => adAndDState.getIn(['form', 'accidentalDeathAndDismembermentParentSelected']),
      false
    ),
  }));

const makeSelectADAndDBenefitsTugoErrors = () =>
  createSelector(selectADAndDBenefitsTugo, (state) => state.get('errors'));

export {
  makeSelectADAndDBenefitsTugo,
  makeSelectADAndDBenefitsTugoErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.ADAndDBenefits/selectors.js